var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVyzkousetZdarmaV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 207.91 232.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nepojmenovan\\xFD_p\\u0159echod_77",
    x1: 151.2,
    y1: 129.44,
    x2: 198.1,
    y2: 96.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#33203f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770070"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#51280c",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.46,142.02s38.9,1.08,50.62-15.32c11.72-16.4-20.74-32.88-20.74-32.88l-37.16,3.52,7.28,44.67Z",
    style: {
      fill: "url(#Nepojmenovan\xFD_p\u0159echod_77)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.77,
    y: 14.43,
    width: 142.89,
    height: 217.69,
    rx: 34.67,
    ry: 34.67,
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.78 21.14 101.2 0 68.4 20.61 96.78 21.14",
    style: {
      fill: "#051f1f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.38,192.25c-1.6-.16-3.56-.41-3.56-2.27,0-1.65,1.75-2.58,3.82-2.58s3.82.72,3.87,2.53h6.81c.26-5.26-4.85-7.95-10.78-7.95s-10.68,2.63-10.68,8.21c0,6.04,6.5,6.71,11.51,7.38,1.75.26,3.56.46,3.56,2.48-.05,2.22-2.17,2.84-4.28,2.84-2.06.05-4.02-.88-4.08-2.94h-7.22c.26,6.6,5.99,8.26,11.61,8.26s11.04-2.22,11.2-8.15c.15-6.66-6.19-7.12-11.76-7.79",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5,179.56l-.05,3.15h-4.7v5.11h4.59v19.71h7.02v-19.71h7.84v-5.11h-7.84v-2.99c0-5.32,4.7-5.11,8.41-3.72l.72-5.37c-8.15-2.48-16-1.24-16,8.93",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.35,201.69c-4.13,1.5-8.41,1.24-8.41-3.92v-9.65h8.1v-5.42h-8.1v-7.74h-5.78l-.77,7.74h-5.21v4.95l4.7.46v9.8c0,10.22,7.59,11.61,16.15,9.24l-.67-5.47Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.09,175.92v-6.67h1.69c1.97,0,3.05,1.57,3.05,3.31s-1.04,3.36-3.05,3.36h-1.69ZM46.15,172.55c0-2.77-1.86-5.39-5.33-5.39h-4.04v10.86h4.04c3.51,0,5.38-2.69,5.33-5.47",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.39,169.16h2.33c.99,0,1.6.73,1.6,1.65.02.93-.62,1.69-1.6,1.69h-2.33v-3.34ZM50.42,174.42h1.94l2.24,3.59h2.49v-.33l-2.46-3.62c1.24-.61,1.94-1.82,1.94-3.2,0-1.93-1.35-3.73-3.84-3.73-1.55-.02-3.09,0-4.65,0v10.88h2.33v-3.59Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.46,172.58c0-2.3,1.52-3.47,3.23-3.47s3.22,1.15,3.22,3.47-1.54,3.5-3.23,3.5-3.22-1.12-3.22-3.5M69.23,172.58c0-3.65-2.69-5.61-5.53-5.61s-5.58,1.94-5.58,5.61,2.63,5.63,5.53,5.63c3.29,0,5.58-2.32,5.58-5.63",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.46 171.8 79.61 178.05 80.31 178.05 80.31 167.14 77.98 167.14 77.98 173.31 71.87 167.09 71.14 167.09 71.14 178.02 73.46 178.02 73.46 171.8",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.18 173.42 89.22 173.42 89.22 171.39 85.18 171.39 85.18 169.18 89.5 169.18 89.5 167.14 82.83 167.14 82.83 178.02 89.62 178.02 89.62 175.91 85.18 175.91 85.18 173.42",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,208.18h0c7.24,0,13.1-5.87,13.11-13.1h-13.11v13.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,181.98h0c-7.24,0-13.1,5.87-13.11,13.1h13.11v-13.1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.88,102.31l103.73,56.09,2.82-9.12-8.64-23.57s16.94-1.03,27.87-.52c10.94.52,15,1.38,15,1.38v-47.49s-12.53-6.71-31.76-9.98-23.28-3.67-23.28-3.67l8.63-28.16L13.88,102.31Z",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.62,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.94,97.54s25.31-1.77,44.8-.07c19.5,1.7,40.76,7.17,48.35,11.7,12.73,7.59,7.59,18.72,7.59,18.72,0,0,4.25-4.04,4.82-7.3s.07-8.37.21-11.06c.14-2.69-3.19-7.8-3.19-7.8l-9.71-5.39-74.44-13.04-16.94,2.84-3.05,3.26,1.56,8.15Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.94 60.32 .19 63.16 0 72.38 111.44 133.06 113.28 125.14 110.74 120.02 26.94 60.32",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.39,2.79L.19,63.16l113.09,61.98-11.07-33.4s39.43-3.41,69.42,3.42c28.3,6.44,36.28,13.66,35.99,24.65,0,0,1.8-16.16-3.6-27.67-6.04-12.88-15.7-29.38-40.65-40.65-24.95-11.27-45.07-15.29-53.73-16.5-8.65-1.21-18.11-2.82-18.11-2.82l7.85-29.38Z",
    style: {
      fill: "#daff06",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.79,110.38c-2.33-12.02-13.06-34.23-70.4-45.95-63.43-12.96-106.05-6.13-136.78-1.53l-.42.25,113.09,61.98-11.07-33.4s39.43-3.41,69.42,3.42c28.3,6.44,36.28,13.66,35.99,24.65,0,0,.35-3.99.17-9.42Z",
    style: {
      fill: "#8cc63f",
      mixBlendMode: "multiply",
      opacity: 0.39,
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.78,37.39c-3.4,4.61-5.11,6.99-8.53,11.87-1.67-.08-2.5-.12-4.17-.18-.34-5.12-.51-7.7-.84-12.88,1.58.12,2.38.18,3.96.31.17,3.14.26,4.7.43,7.82,2.08-2.98,3.12-4.44,5.19-7.32,1.58.15,2.37.23,3.96.39Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.47,38.85c-3.54,4.53-5.31,6.87-8.88,11.69-.73.98-1.42,1.74-2.05,2.28-.63.54-1.27.92-1.92,1.13-.65.21-1.39.3-2.23.26-.61-.03-1.2-.15-1.77-.38-.57-.22-1.02-.5-1.33-.84.87-1.2,1.31-1.79,2.18-2.97.45.5,1.01.77,1.69.81.37.02.69-.05.96-.2.28-.16.56-.42.87-.79-.42-4.98-.63-7.49-1.05-12.54,1.59.16,2.39.24,3.98.42.2,3.04.3,4.56.5,7.57,2.06-2.82,3.09-4.21,5.14-6.93,1.56.19,2.35.29,3.91.49Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.22,42.57c-2.83,2.06-4.25,3.13-7.09,5.34,2.13.23,3.2.35,5.33.6-.4,1.17-.59,1.75-.99,2.92-4.22-.45-6.33-.65-10.55-1.01.31-.96.46-1.45.77-2.41,2.87-2.28,4.3-3.39,7.15-5.53-1.99-.25-2.98-.38-4.97-.61.39-1.2.58-1.79.97-2.98,4.06.53,6.09.81,10.15,1.42-.31.9-.47,1.35-.78,2.25Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.35,46.61c1.22,2.68,1.83,4.01,3.05,6.63-1.87-.26-2.8-.38-4.67-.62-.74-1.62-1.11-2.44-1.85-4.09-.73.47-1.09.7-1.82,1.18-.32.94-.48,1.41-.79,2.36-1.6-.19-2.4-.28-4-.46,2.04-6.08,3.05-9.09,5.08-15.01,1.59.27,2.39.41,3.98.7-1.05,3.02-1.57,4.55-2.62,7.61,2.03-1.25,3.05-1.86,5.08-3.04,2.01.34,3.02.52,5.03.88-2.57,1.48-3.86,2.25-6.45,3.84Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.03,53.32c-.85-.53-1.46-1.21-1.86-2.02-.39-.81-.53-1.72-.4-2.7.15-1.18.59-2.2,1.31-3.04.72-.84,1.65-1.43,2.78-1.77,1.13-.34,2.36-.38,3.68-.13,1.2.23,2.22.64,3.06,1.2.84.57,1.46,1.25,1.86,2.05.4.8.53,1.67.41,2.6-.15,1.13-.58,2.09-1.3,2.89-.72.8-1.64,1.38-2.76,1.74-1.12.36-2.36.44-3.7.24-1.2-.18-2.23-.53-3.08-1.06ZM111.78,50.94c.57-.46.91-1.11,1.02-1.97.08-.62-.05-1.14-.38-1.57s-.83-.71-1.5-.83c-.8-.14-1.48.01-2.05.47-.57.46-.92,1.14-1.03,2.03-.08.63.04,1.15.38,1.57.33.42.83.68,1.5.79.8.13,1.48-.04,2.06-.49Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.23,48.29c-1.41,3.66-2.11,5.52-3.53,9.27-1.51-.29-2.26-.43-3.77-.71.15-.39.22-.59.36-.98-.54.31-1.13.51-1.76.6-.63.09-1.27.08-1.91-.04-1.24-.22-2.19-.69-2.85-1.42-.66-.73-.91-1.66-.77-2.78.05-.42.16-.83.31-1.24.79-2.16,1.19-3.24,1.98-5.38,1.59.34,2.38.51,3.96.85-.74,1.97-1.11,2.97-1.85,4.96-.09.22-.14.45-.17.67-.11.88.34,1.41,1.36,1.61.68.13,1.27.05,1.77-.23.5-.28.87-.77,1.14-1.47.71-1.87,1.06-2.79,1.76-4.64,1.58.36,2.37.55,3.96.92Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.89,58.27c-.87-.36-1.55-.72-2.01-1.1.7-.84,1.05-1.26,1.75-2.08.48.38,1.06.73,1.75,1.04.69.31,1.37.54,2.05.69,1.21.26,1.84.17,1.9-.28.02-.19-.1-.35-.37-.51-.27-.15-.73-.33-1.33-.56-.81-.3-1.48-.6-2-.87-.52-.26-.95-.62-1.31-1.06-.36-.44-.49-.99-.41-1.63.15-1.12.82-1.85,2.01-2.19,1.2-.34,2.68-.28,4.45.16.8.2,1.57.47,2.3.79s1.35.67,1.88,1.04c-.68.76-1.01,1.15-1.69,1.92-.88-.7-1.96-1.21-3.25-1.52-.61-.15-1.07-.19-1.39-.13-.32.06-.49.2-.52.41-.02.19.1.36.37.51.27.15.73.37,1.37.62.78.31,1.44.6,1.95.87.51.28.94.64,1.29,1.07.35.44.49.95.41,1.55-.14,1.07-.81,1.77-2.01,2.11-1.2.34-2.68.33-4.43-.03-.97-.2-1.9-.48-2.77-.84ZM144.72,47.61c-1.39.68-2.09,1.03-3.49,1.75-1.36-.35-2.04-.53-3.4-.88-.76-1.29-1.14-1.94-1.89-3.24,1.02.27,1.53.4,2.55.67.55.7.83,1.04,1.38,1.73.87-.32,1.3-.47,2.16-.78,1.08.29,1.61.44,2.69.74Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.64,59.76c-3.29-.87-4.94-1.3-8.24-2.11,0,1.02.79,1.71,2.36,2.09.5.12.99.18,1.48.18.48,0,.93-.08,1.34-.22.55.95.83,1.42,1.38,2.35-1.41.43-3.06.43-4.94-.01-1.19-.28-2.22-.69-3.08-1.24-.86-.55-1.5-1.2-1.91-1.94-.41-.74-.56-1.54-.44-2.39.13-1.01.54-1.85,1.22-2.51.68-.66,1.57-1.08,2.65-1.26,1.09-.18,2.29-.08,3.62.29,1.12.31,2.07.75,2.86,1.3.79.56,1.37,1.19,1.74,1.89.37.7.5,1.44.4,2.2-.06.42-.2.88-.42,1.37ZM148.93,55.15c-.46.16-.82.45-1.08.89,1.85.47,2.77.71,4.62,1.2.08-.47-.06-.88-.41-1.26-.35-.37-.84-.65-1.48-.81-.63-.17-1.18-.18-1.65-.02Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.55,61.72c-.05.14-.07.23-.08.27-.06.48.25.81.93,1,.37.1.77.13,1.21.08.09.87.13,1.3.22,2.17-.82.12-1.81.03-2.98-.27-1.16-.3-2.05-.76-2.67-1.38-.62-.62-.88-1.33-.77-2.13.04-.31.11-.57.21-.79.45-1.06.68-1.59,1.13-2.65-.66-.19-.99-.28-1.65-.46.36-.84.54-1.26.9-2.1.65.19.98.29,1.63.48.35-.83.53-1.24.88-2.06,1.56.48,2.35.72,3.91,1.22-.35.8-.52,1.2-.87,2.01,1.01.31,1.52.46,2.53.78-.35.8-.52,1.2-.87,2.01-1.01-.3-1.52-.45-2.53-.75-.45,1.03-.67,1.54-1.12,2.58Z",
    style: {
      fill: "#006837",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.64,66.04c-4.16,3.69-6.25,5.62-10.44,9.61,3.15-.1,4.73-.14,7.88-.2-.59,1.86-.88,2.8-1.47,4.67-6.15.21-9.23.36-15.38.76.47-1.56.7-2.35,1.17-3.9,4.2-4.15,6.3-6.15,10.47-10.01-2.9,0-4.34.02-7.24.08.59-1.94.89-2.91,1.48-4.83,5.87,0,8.81.03,14.67.2-.46,1.45-.69,2.18-1.15,3.63Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.81,62.47c3,.1,4.51.16,7.51.3,1.74.08,3.21.46,4.41,1.1,1.2.65,2.08,1.52,2.62,2.62.55,1.1.73,2.36.55,3.8-.24,1.91-.9,3.58-1.97,5.01-1.08,1.44-2.45,2.55-4.14,3.34-1.68.79-3.54,1.21-5.56,1.23-3.58.05-5.38.08-8.96.19,2.23-7.13,3.34-10.65,5.55-17.6ZM73.99,75.35c1.45,0,2.63-.46,3.55-1.38.92-.92,1.47-2.1,1.65-3.55.12-.98-.08-1.75-.6-2.3-.53-.55-1.35-.85-2.48-.89-.86-.03-1.28-.04-2.14-.06-1.04,3.25-1.56,4.89-2.6,8.18,1.05,0,1.57,0,2.62,0Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.28,77.32c-2.54-.11-3.81-.15-6.36-.23-.81,1.12-1.22,1.68-2.03,2.81-2.38-.04-3.56-.05-5.94-.06,5.11-6.67,7.64-9.86,12.69-15.94,2.2.18,3.3.28,5.49.49.76,6.45,1.15,9.64,1.93,15.95-2.24-.1-3.36-.14-5.59-.22-.08-1.12-.12-1.68-.19-2.79ZM95.98,73.41c-.11-1.65-.17-2.48-.29-4.14-1.19,1.57-1.78,2.36-2.97,3.97,1.3.06,1.95.1,3.26.17Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32,75.01c-.9.88-2.1,1.5-3.58,1.85.89,1.82,1.33,2.73,2.22,4.52-2.32-.18-3.49-.27-5.81-.42-.75-1.57-1.12-2.36-1.86-3.95-.55-.04-.83-.06-1.38-.1-.53,1.5-.79,2.25-1.32,3.76-2.24-.13-3.37-.19-5.61-.29,2.13-6.15,3.19-9.18,5.3-15.16,2.97.33,4.45.5,7.42.88,2.17.27,3.8.93,4.9,1.92,1.09,1,1.54,2.25,1.34,3.75-.17,1.28-.7,2.36-1.61,3.24ZM114.33,69.87c-.75-.08-1.12-.12-1.87-.2-.49,1.38-.74,2.07-1.24,3.46.92.08,1.38.13,2.3.21.77.07,1.4-.04,1.87-.35.47-.3.75-.76.83-1.39.13-1-.5-1.58-1.89-1.74Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5,70.76c-1.99,5.03-2.99,7.59-5,12.79-2.03-.25-3.04-.37-5.07-.6.91-2.43,1.37-3.64,2.28-6.03-2.12,1.73-3.18,2.61-5.3,4.43-.98-.11-1.47-.16-2.46-.27-.76-2.13-1.13-3.2-1.89-5.36-.93,2.47-1.39,3.72-2.32,6.23-2.04-.19-3.05-.28-5.09-.45,2.08-5.7,3.12-8.51,5.18-14.04,1.81.27,2.71.4,4.52.68,1.04,3.21,1.56,4.8,2.6,7.93,3.15-2.58,4.72-3.82,7.84-6.19,1.88.34,2.82.51,4.7.86Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.46,83.39c-2.5-.41-3.75-.61-6.26-.98-.78.8-1.17,1.21-1.94,2.02-2.34-.32-3.51-.47-5.86-.77,4.91-4.82,7.34-7.08,12.18-11.31,2.16.44,3.24.67,5.4,1.14.88,5.3,1.32,7.91,2.21,13.05-2.2-.37-3.3-.54-5.5-.88-.1-.91-.15-1.36-.24-2.27ZM155.09,80.2c-.15-1.34-.22-2.02-.36-3.37-1.13,1.11-1.7,1.67-2.84,2.82,1.28.22,1.92.33,3.2.55Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVyzkousetZdarmaV2);
export default __webpack_public_path__ + "static/media/vyzkouset-zdarma_v2.242c9780083d2ffbc91e1cc00682529d.svg";
export { ForwardRef as ReactComponent };